/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./VTemplateCompiler.vue?vue&type=template&id=14273643"
import script from "./VTemplateCompiler.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTemplateCompiler.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports